export default {
	label: 'Measure | Measures',
	type: 'Type',
	status: 'Status | Statuses',
	addMeasure: 'Add measure',
	reference: 'Reference',
	category: {
		label: 'Kategooria | Kategooriad',
		error: {
			selectAtLeastOne: 'Select at least 1 category',
		},
	},
	overrideType: 'Module security need ({module}) overrides measure ({method})',
	search: 'Search measure',
	force: 'Force',
	serviceProvider: 'Service provider',
	ruleComment: 'Rule comment',
	special: 'Special',
	withComments: 'With comments',
	withRuleComments: 'With rule comments',
	withoutComments: 'Without comments',
	withoutRuleComments: 'Without comments',
	securityType: 'Security need',
}
